module.exports = __webpack_public_path__ + "static/img/Tutorial sin texto Redpie4 (1)-20.52fd732d.jpg";